import { render, staticRenderFns } from "./substance.vue?vue&type=template&id=b24e8ed2&scoped=true&"
import script from "./substance.vue?vue&type=script&lang=js&"
export * from "./substance.vue?vue&type=script&lang=js&"
import style0 from "./substance.vue?vue&type=style&index=0&id=b24e8ed2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e8ed2",
  null
  
)

export default component.exports